import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        context: '=',
        canManageCourse: '=',
        course: '=',
        onRegister: '&'
    },
    template: `
<div class="color03">
    <h2>{{ 'licence.Licence points' | translate }}</h2>
    <ul class="items06" ng-if="vm.form.model.courseVersionLicences">
        <form-row error="vm.form.errors.courseVersionLicences" ng-if="vm.lodash.isString(vm.form.errors.courseVersionLicences)">
            <form-row-error></form-row-error>
        </form-row>
        <li ng-repeat="(key, item) in vm.form.model.courseVersionLicences">
            <div class="form">
                <form-row error="vm.form.errors.courseVersionLicences[key].licenceId">
                  <label class="label">{{ 'licence.Licence' | translate }}*</label>
                  <div class="items">
                    <select class="form-control"
                            ng-model="item.licenceId"
                            ng-disabled="vm.hasPublishedOccurrence"
                            ng-options="licence.id as licence.name for licence in vm.licences">
                    </select>
                    <form-row-error></form-row-error>
                  </div>
                </form-row>
                <form-row error="vm.form.errors.courseVersionLicences[key].points">
                    <label class="label">{{ 'licence.Points' | translate }}*</label>
                    <div class="items">
                        <input
                            ng-keyup="vm.isFloat(key)"
                            class="form-control"
                            value="{{ item.points }}"
                            ng-model="item.points"
                            ng-readonly="vm.hasPublishedOccurrence"
                        >
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <ul class="actions01">
                    <li ng-if="vm.canManageCourse && !vm.hasPublishedOccurrence && !vm.course.isArchived">
                        <a class="btn delete" ng-click="vm.remove(key)">{{ 'general.Remove' | translate }}</a>
                    </li>
                </ul>
            </div>
        </li>
    </ul>
    <ul class="actions01">
        <li ng-if="vm.canManageCourse && !vm.hasPublishedOccurrence && !vm.course.isArchived">
            <a class="btn add" ng-click="vm.add()">{{ 'licence.Add new licence' | translate }}</a>
        </li>
    </ul>
</div>
    `
})

export default class {
    constructor ($translate, toastr, lodash, ModalService, CourseVersionService,
                 LicenceResource, CourseVersionResource, NumberService) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.lodash = lodash;
        this.ModalService = ModalService;
        this.CourseVersionService = CourseVersionService;
        this.LicenceResource = LicenceResource;
        this.CourseVersionResource = CourseVersionResource;
        this.NumberService = NumberService;
    }

    $onInit () {
        this.hasPublishedOccurrence = this.CourseVersionService.getPublishedOccurrenceCount(this.form.model);
        this.form.errors.courseVersionLicences = [];
        this.initLicences();

        // bind child component to parent
        this.onRegister({ $ctrl: this });
    }

    isFloat (licenceKey) {
        if (this.form.errors.courseVersionLicences === undefined) {
            this.form.errors.courseVersionLicences = [];
        }
        this.form.errors.courseVersionLicences[licenceKey] = {
            points: this.$translate.instant('licencePoint.Points must be number with up to two decimal places')
        };

        if (this.NumberService.isFloat(this.form.model.courseVersionLicences[licenceKey].points)) {
            delete this.form.errors.courseVersionLicences[licenceKey].points;
        }
    }

    initLicences () {
        this.licences = [];
        this.LicenceResource.query({ pageSize: 0, courseId: this.form.model.courseId }).$promise
            .then(licences => {
                this.licences = licences;
                // Convert licenceId to integer after licences are loaded to ensure proper matching
                this.lodash.forEach(this.form.model.courseVersionLicences, licence => {
                    licence.licenceId = licence.licenceId !== null ? parseInt(licence.licenceId, 10) : null;
                });
            });
    }

    add () {
        if (!this.form.model.courseVersionLicences) {
            this.form.model.courseVersionLicences = [];
        }
        this.form.model.courseVersionLicences.push({});
    }

    remove (index) {
        const message = this.$translate.instant('licence.Are you sure you wish to remove the licence?');
        this.ModalService.confirm(message).then(() => {
            const versionLicence = this.form.model.courseVersionLicences[index];
            if (!versionLicence.id) {
                this.form.model.courseVersionLicences.splice(index, 1);
                return;
            }
            this.CourseVersionResource.deleteLicence({ id: versionLicence.id }).$promise
                .then(() => {
                    this.form.model.courseVersionLicences.splice(index, 1);
                    this.toastr.success(this.$translate.instant('licence.Licence removed'));
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/licence/index.js